import React from 'react';

export function HomePage() {
  return <h1>Hi there!</h1>;
}
